import { Link } from "react-router-dom";
import { Code2, Cloud, Headset, ArrowUpRight, Check } from "lucide-react";
import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { SpotlightCard } from "@/components/SpotlightCard";
import { SERVICES } from "@/data";

const ICONS = { software: Code2, consulting: Headset, cloud: Cloud };

export default function Services() {
  return (
    <>
      <PageHeader
        eyebrow="Services"
        title="What we build"
        subtitle="Three core practices, one team. Whether you need a product built, systems modernized or infrastructure that scales, we cover the full lifecycle."
      />

      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 space-y-6">
        {SERVICES.map((s, i) => {
          const Icon = ICONS[s.key];
          return (
            <Reveal key={s.key} delay={i * 0.05}>
              <SpotlightCard>
                <div className="p-8 lg:p-12 grid lg:grid-cols-12 gap-8 items-start">
                  <div className="lg:col-span-1">
                    <span className="font-mono-j text-cyan-400 text-lg">{s.index}</span>
                  </div>
                  <div className="lg:col-span-5">
                    <div className="w-14 h-14 rounded-xl bg-cyan-500/10 grid place-items-center mb-6">
                      <Icon className="text-cyan-400" size={26} />
                    </div>
                    <h2 className="font-display font-bold text-3xl sm:text-4xl text-white">{s.title}</h2>
                    <p className="font-mono-j text-sm text-cyan-400 mt-3">{s.tagline}</p>
                  </div>
                  <div className="lg:col-span-6">
                    <p className="text-zinc-400 text-lg leading-relaxed">{s.desc}</p>
                    <ul className="mt-6 grid sm:grid-cols-2 gap-3">
                      {s.points.map((p) => (
                        <li key={p} className="flex items-center gap-2 text-zinc-300">
                          <Check size={16} className="text-cyan-400 shrink-0" /> {p}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </SpotlightCard>
            </Reveal>
          );
        })}
      </section>

      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-24">
        <Reveal>
          <div className="rounded-3xl border border-white/10 bg-[#0A0A0A] p-10 lg:p-16 flex flex-col lg:flex-row lg:items-center justify-between gap-8">
            <div>
              <h2 className="font-display font-bold text-3xl sm:text-4xl text-white max-w-lg">
                Not sure where to start? Let's scope it together.
              </h2>
              <p className="mt-4 text-zinc-400 max-w-md">Book a free discovery call and we'll map the fastest path to your goal.</p>
            </div>
            <Link to="/contact" data-testid="services-cta" className="inline-flex items-center gap-2 bg-cyan-500 text-black font-semibold px-7 py-4 rounded-full hover:bg-cyan-400 hover:scale-105 transition-transform shrink-0">
              Start a Project <ArrowUpRight size={18} />
            </Link>
          </div>
        </Reveal>
      </section>
    </>
  );
}
